// extracted by mini-css-extract-plugin
module.exports = {"reviewListContainer":"styles__reviewListContainer___DQv9C","noReviews":"styles__noReviews___2Jk9U"};